import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Dropdown } from 'antd'
import React, { ReactNode, useState } from 'react'
import { TemplateQuestionResetParams } from 'src/features/templateEdit/common/types'
import { InputFormSection } from 'src/features/templateEdit/itemAppender/ResponseDropDown/components/InputFormSection/InputFormSection'
import { MultipleChoiceSectionWithTabs } from 'src/features/templateEdit/itemAppender/ResponseDropDown/components/MultipleChoiceSectionWithTabs/MultipleChoiceSectionWithTabs'
import { useMultipleChoiceDrawer } from 'src/features/templateEdit/itemAppender/ResponseDropDown/hooks/useMultipleChoiceDrawer'
import {
  SelectAnswerWrapper,
  SelectResponseTableCell,
} from 'src/features/templateEdit/itemAppender/ResponseDropDown/ResponseDropDown.dump'
import { DisabledTableCellBackgroundColor } from 'src/features/theme/KdsThemeColor'

interface OwnProps {
  selectAnswer: ReactNode
  hasLogic: boolean
  setSelectAnswer: (selectAnswer: ReactNode) => void
  onChangeQuestionType: (key: string) => void
  isEmployeeCheck: boolean
  dispatchUpdateTemplateNode: (params: TemplateQuestionResetParams) => void
}

const ResponseDropDown: React.FC<OwnProps> = (props: OwnProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const multipleChoiceDrawer = useMultipleChoiceDrawer()

  const onOpenChange = (open: boolean) => {
    if (props.hasLogic || props.isEmployeeCheck) return
    if (multipleChoiceDrawer.isVisible) return
    setIsOpen(open)
  }

  const groundArea = (
    <SelectResponseTableCell
      theme={{
        minWidth: '240px',
        backgroundColor: props.hasLogic && DisabledTableCellBackgroundColor,
      }}
    >
      <div
        // コンテンツが長いとセルが膨張してヘッダーの回答列幅とずれるため、
        // width: 0で膨張を抑え、minWidth: 100%で描画時にセル幅に合わせる
        style={{
          display: 'flex',
          width: 0,
          minWidth: '100%',
          overflow: 'hidden',
        }}
        data-testid="response-drop-down"
      >
        <SelectAnswerWrapper>{props.selectAnswer}</SelectAnswerWrapper>
        {!props.isEmployeeCheck && (
          <div
            style={{
              minWidth: 20,
              marginRight: 12,
              alignItems: 'center',
              display: 'flex',
            }}
          >
            {isOpen ? <ExpandLess /> : <ExpandMore />}
          </div>
        )}
      </div>
    </SelectResponseTableCell>
  )

  const hoverArea = (
    <div style={{ display: 'flex' }} data-testid="response-drop-down-hover">
      <MultipleChoiceSectionWithTabs
        openMultipleChoiceDrawer={multipleChoiceDrawer.open}
        onCloseDropdown={() => setIsOpen(false)}
        dispatchUpdateTemplateNode={props.dispatchUpdateTemplateNode}
      />
      <InputFormSection
        onChangeQuestionType={props.onChangeQuestionType}
        onCloseDropdown={() => setIsOpen(false)}
      />
    </div>
  )

  return (
    <>
      <Dropdown
        destroyPopupOnHide // 閉じたあとも要素が残っているとE2Eテスト時に厄介なのできっちり消す
        dropdownRender={() => hoverArea}
        trigger={['click']}
        open={isOpen}
        onOpenChange={onOpenChange}
      >
        {groundArea}
      </Dropdown>
      {multipleChoiceDrawer.renderDrawer()}
    </>
  )
}

export default ResponseDropDown
